import { render, staticRenderFns } from "./VehicleAssign.vue?vue&type=template&id=93ea30f8&scoped=true&"
import script from "./VehicleAssign.vue?vue&type=script&lang=js&"
export * from "./VehicleAssign.vue?vue&type=script&lang=js&"
import style0 from "./VehicleAssign.vue?vue&type=style&index=0&id=93ea30f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ea30f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAutocomplete,VCard})
